import { Brand } from '../branded-types';
import { z } from 'zod/v4';

export type OperatorMappingId = Brand<string, 'operatorMappingId'>;
export type OperatorDropDownId = Brand<string, 'operatorDropDownId'>;

export interface IOperatorMapping {
  id?: OperatorMappingId;
  name?: string;
  url: string;
  operatorId: string;
  dropDownOptions: IOperatorDropDown[];
  onDemandSortExternalRef?: string | null;
  comfortSortExternalRef?: string | null;
  publicTransportProductGroup?: string | null;
}

export interface IOperatorDropDown {
  id?: OperatorDropDownId;
  name: string;
  operatorMappingId?: OperatorMappingId;
}

export const OPERATOR_MAPPING_ID_SCHEMA: z.ZodType<OperatorMappingId, string> =
  z
    .uuid()
    .transform(s => s as OperatorMappingId)
    .nonoptional();

export const OPERATOR_DROP_DOWN_SCHEMA: z.ZodType<IOperatorDropDown> = z.object(
  {
    id: z
      .uuid()
      .transform((s: string) => s as OperatorDropDownId)
      .optional(),
    operatorMapping: z
      .uuid()
      .transform((s: string) => s as OperatorMappingId)
      .optional(),
    name: z.string(),
  }
);

export const OPERATOR_MAPPING_SCHEMA: z.ZodType<IOperatorMapping> = z.object({
  id: z
    .uuid()
    .transform((s: string) => s as OperatorMappingId)
    .optional(),
  name: z.string().optional(),
  url: z.string(),
  operatorId: z.string(),
  dropDownOptions: z.array(OPERATOR_DROP_DOWN_SCHEMA),
  onDemandSortExternalRef: z.string().nullable().optional().default(null),
  comfortSortExternalRef: z.string().nullable().optional().default(null),
  publicTransportProductGroup: z.string().nullable().optional().default(null),
});

export const OPERATOR_MAPPINGS_SCHEMA: z.ZodType<IOperatorMapping[]> = z.array(
  OPERATOR_MAPPING_SCHEMA
);
